const verification = {
    title: '設計検証項目一覧',
    disabledTitle: '設計検証は利用できません',
    disabled: 'このテナントでは設計検証機能は有効になっていません。管理者にお問い合わせください。',
    description: '設計検証項目の管理とExcel帳票出力',
    units: 'ユニット',
    items: '項目',
    modelName: '機種名',
    sessionTitle: 'セッションタイトル',
    sessionDescription: '説明',
    selectSession: 'セッションを選択してください',
    noUnits: 'ユニットがありません',
    addUnit: 'ユニット追加',
    editUnit: 'ユニット編集',
    deleteUnit: 'ユニット削除',
    addItem: '項目追加',
    editItem: '項目編集',
    unitNumber: 'ユニット番号',
    unitNameLabel: 'ユニット名',
    primary: '主',
    secondary: '副',
    right: '右',
    reviewRequired: '要',
    reviewNotRequired: '否',
    standardTargetHelp: '基準・目標値を入力してください（最重要項目）',
    classificationLabels: {
      performance: '性能',
      function: '機能',
      reliability: '信頼・耐久性',
      safety: '安全性',
      cost: 'コスト',
      maintenance: '保守',
    },
    methodLabels: {
      unit_prototype: 'ユニット試作',
      pre_test: '事前テスト',
      design_calc: '設計計算',
      competitor_comp: '他社比較',
      analysis: '解析',
      dr1: 'DR1',
      knowhow: 'ノウハウ',
      actual_confirm: '実機確認',
    },
    sessionCreated: 'セッションを作成しました',
    unitAdded: 'ユニットを追加しました',
    itemAdded: '項目を追加しました',
    delete: {
      sessionTitle: '検証セッションを削除',
      sessionMessage:
        '「{{name}}」を削除します。配下のユニット{{unitCount}}件と検証項目{{itemCount}}件もすべて削除されます。この操作は取り消せません。',
      unitTitle: 'ユニットを削除',
      unitMessage:
        '「{{name}}」を削除します。配下の検証項目{{itemCount}}件もすべて削除されます。この操作は取り消せません。',
      itemTitle: '検証項目を削除',
      itemMessage: '「{{name}}」を削除してもよろしいですか？この操作は取り消せません。',
    },
    chat: {
      title: 'AI検証チャット',
      openTooltip: 'AI検証チャット',
      closeTooltip: 'チャットを閉じる',
    },
    sessions: {
      title: '検証セッション一覧',
      noSessions: '検証セッションがありません',
      create: '新規セッション作成',
    },
    table: {
      unit: '大分類ユニット',
      specification: '仕様',
      itemName: '項目',
      classification: '分類',
      standardTarget: '基準・目標',
      verificationMethod: '検証方法',
      review: '審査',
      qualityRecordNo: '品質記録書NO.',
      qualityRecordTitle: '品質記録書タイトル',
    },
    export: {
      dialogTitle: 'Excel出力',
      excel: 'Excel出力',
      sessionLabel: 'セッション',
      download: 'ダウンロード',
      exporting: 'エクスポート中...',
      error: 'エクスポートに失敗しました',
    },
    drbfmLink: 'この項目はDRBFM分析から生成されました',
    drbfmLinkTooltip: 'DRBFM分析結果を表示',
    createSessionFailed: 'セッションの作成に失敗しました',
    saveItemFailed: '項目の保存に失敗しました',
    saveUnitFailed: 'ユニットの保存に失敗しました',
    deleteFailed: '削除に失敗しました',
    sessionsLoadFailed: 'セッション一覧の読み込みに失敗しました',
    sessionLoadFailed: 'セッションの読み込みに失敗しました',
  };

export default verification;
